import React, { createElement, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { colors, CssBaseline } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { zhTW } from "date-fns/locale";
import jwtDecode from "jwt-decode";
import "./App.css";

import { AlertProvider } from "./components/Alert";

// 前台
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import NewsPage from "./pages/NewsPage";
import NewsContentPage from "./pages/NewsContentPage";
import AboutPage from "./pages/AboutPage";
import SearchPage from "./pages/SearchPage";
import JoinInfo from "./pages/JoinInfo";
import JoinPage from "./pages/JoinPage";
import JoinSearch from "./pages/JoinSearch";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import SubscribePage from "./pages/SubscribePage";
import PrivacyPage from "./pages/PrivacyPage";
import IdeaPage from "./pages/IdeaPage";
import BrandStory from "./pages/BrandStory";
import AdvantagePage from "./pages/AdvantagePage";
import FundsPage from "./pages/FundsPage";
import BuyHouse from "./pages/BuyHouse";
import ConsultationPage from "./pages/ConsultationPage";
import CoursePage from "./pages/CoursePage";
import InvestmentPage from "./pages/InvestmentPage";
import WholeHousePage from "./pages/WholeHousePage";
import CourseApply from "./pages/CourseApply";
import TextBooks from "./pages/Textbooks";
import InterestCalculationPage from "./pages/InterestCalculationPage";
import CasePage from "./pages/CasePage";
import SimpleInfo from "./pages/SimpleInfo";
import PrintForeclosures from "./pages/PrintForeclosures";
// import Sub
// 施工中
import ConstructionPage from "./pages/ConstructionPage";
// 後台
import AuthLayout from "./components/Auth.js";
import AdminLayout from "./components/Admin.js";
import { isThisQuarter } from "date-fns";

const consoleHomeRoute = "/console/sale-obj";
const consoleLoginRoute = "/console/login";
const webSiteRoute = [
  { path: "/", page: HomePage },
  { path: "/news/:id", page: NewsPage },
  { path: "/news-content/:id", page: NewsContentPage },
  { path: "/about-page", page: AboutPage },
  { path: "/search", page: SearchPage },
  { path: "/join-search", page: JoinSearch },
  { path: "/join-info", page: JoinInfo },
  { path: "/join", page: JoinPage },
  { path: "/regist-page", page: RegisterPage },
  { path: "/log-in", page: LoginPage },
  { path: "/forget-password", page: ForgotPasswordPage },
  { path: "/privacy", page: PrivacyPage },
  { path: "/brand-story", page: BrandStory },
  { path: "/idea", page: IdeaPage },
  { path: "/advantage", page: AdvantagePage },
  { path: "/funds", page: FundsPage },
  { path: "/buy-house", page: BuyHouse },
  { path: "/consultation", page: ConsultationPage },
  { path: "/course", page: CoursePage },
  { path: "/investment", page: InvestmentPage },
  { path: "/whole-house", page: WholeHousePage },
  { path: "/subscribe-page", page: SubscribePage },
  { path: "/course-apply", page: CourseApply },
  { path: "/textbooks", page: TextBooks },
  { path: "/interest-calculation", page: InterestCalculationPage },
  { path: "/case/:id", page: CasePage },
  { path: "/simple-info/:id", page: SimpleInfo },
  { path: "/print", page: PrintForeclosures },
  // 施工
  { path: "/construction-page", page: ConstructionPage },
];
//禁止右鍵
// {
//   isThisQuarter &&
//     window.addEventListener("mousedown", function (e) {
//       document.oncontextmenu = function (e) {
//         if (e.button == 2) {
//           return false;
//         }
//       };
//     });
// }
//禁止control+c
window.addEventListener("keydown", function (e) {
  if (e.ctrlKey && e.keyCode == 67) {
    e.returnValue = false;
  }
});

export default function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#103775",
      },
      secondary: {
        main: "#C67500",
        light: "#E1B663",
      },
    },
    typography: {
      fontFamily: ["Noto Sans TC", "sans-serif"].join(","),
    },
    props: {
      MuiTextField: {
        variant: "outlined",
        size: "small",
      },
      MuiButton: {
        disableElevation: true,
      },
      MuiButtonGroup: {
        disableElevation: true,
      },
    },
    overrides: {
      MuiButton: { root: { height: 40 } },
    },
  });

  const consoleTheme = createMuiTheme({
    palette: {
      primary: {
        main: colors.teal[500],
      },
      secondary: {
        main: colors.amber[500],
      },
    },
    typography: {
      fontFamily: ["Noto Sans TC", "sans-serif"].join(","),
    },
    props: {
      MuiTextField: {
        variant: "outlined",
        size: "small",
      },
      MuiButton: {
        disableElevation: true,
      },
      MuiButtonGroup: {
        disableElevation: true,
      },
    },
    overrides: {
      MuiButton: { root: { height: 40 } },
    },
  });

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <AlertProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
            <Router>
              <ScrollToTop />
              <Switch>
                <Route exact path={webSiteRoute.map((item) => item.path)}>
                  <Layout>
                    {webSiteRoute.map((item) => (
                      <Route exact path={item.path} key={item.path}>
                        {createElement(item.page)}
                      </Route>
                    ))}
                  </Layout>
                </Route>
                <ThemeProvider theme={consoleTheme}>
                  <AlertProvider>
                    <Route path="/console">
                      <SwitchConsoleRoute />
                      {/* 登入路由 */}
                      <Route path={consoleLoginRoute}>
                        <AuthLayout />
                      </Route>
                      {/* 一般路由 */}
                      <Switch>
                        <Route path="/console" component={AdminLayout} />
                      </Switch>
                    </Route>
                  </AlertProvider>
                </ThemeProvider>
              </Switch>
            </Router>
          </MuiPickersUtilsProvider>
        </AlertProvider>
      </ThemeProvider>
    </>
  );
}
function getToken() {
  const token = localStorage.getItem("@fullhouseToken");
  if (!token) return false;
  const { exp } = jwtDecode(token);
  if (Date.now() >= exp * 1000) {
    localStorage.clear();
    return false;
  } else {
    return true;
  }
}
function SwitchConsoleRoute() {
  const { pathname } = useLocation();
  if (
    (pathname === consoleLoginRoute || pathname === "/console") &&
    getToken()
  ) {
    // 在登入情況下進到登入頁
    return <Redirect to={consoleHomeRoute} />;
  } else if (pathname !== consoleLoginRoute && !getToken()) {
    // 在未登入情況進到非登入(後台)畫面
    return <Redirect to={consoleLoginRoute} />;
  }
  return null;
}
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
